import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { PATH_SEGMENTS, route } from '../config/paths';

/**
 * Old bookmark: `/live-assist/:id` with numeric interaction id → replay.
 */
const LiveAssistLegacyRedirect: React.FC = () => {
  const { interactionId } = useParams<{ interactionId: string }>();
  if (interactionId && /^\d+$/.test(interactionId)) {
    return <Navigate to={route(PATH_SEGMENTS.LIVE_ASSIST, PATH_SEGMENTS.LIVE_ASSIST_REPLAY, interactionId)} replace />;
  }
  return <Navigate to={route(PATH_SEGMENTS.LIVE_ASSIST)} replace />;
};

export default LiveAssistLegacyRedirect;
